import * as React from 'react';
import { RouteComponentProps } from 'react-router';
//import * as Scroll from 'react-scroll';
import * as DTO from '../service/DTOs';
import * as TF from '../service/tradeflow';
import { MainFrameComponent } from './MainFrame';
import { Header } from './Header';
import { Footer } from './Footer';
import * as State from '../service/AppState';
import * as API from '../service/apisvc';
import * as Session from '../service/Session';

import 'isomorphic-fetch';

//var PropTypes = require('prop-types');

type OtcRepoComponentProptype = RouteComponentProps<{}>;

export class OtcRepoComponent extends React.Component<RouteComponentProps<{}>, State.AppState> {
    node_hb: HTMLDivElement | null;
    repoInit: boolean;
    constructor(props: RouteComponentProps<{}>) {
        super(props);
        this.node_hb = null;
        //this.state = {
        //    syshdr: { sstamp: '' },
        //    online: undefined,
        //    alerts: []
        //};
        //this.context.
        this.state = State.default;
        this.repoInit = false;
    }

    processSysCmd(cmd: TF.SystemCommand) {
        //console.log('setApiHeaderResponse call {' + data + '}');
        if (this.refs.cmpMainFrameRef) {
            //this.setState({
            //    appstate: { syshdr: data, online: (data.time ? true : false) },
            //});
        }

        return { return: 0, sstamp: this.state.syshdr.sstamp };
    }

    processUpdateConfig(cfg: DTO.AppConfig) {
        this.setState({ appId: cfg.idapp, sharedChatId: cfg.sharedchatid, appFamily: cfg.appFamily });
        return {};
    }

    //processHeartbeat(data: DTO.SystemHeader) {
    //    //console.log('setApiHeaderResponse call {' + data + '}');
    //    if (this.refs.cmpMainFrameRef) {
    //        this.setState({
    //            syshdr: data, online: (data.time ? true : false) ,
    //        });
    //    }

    //    return {return: 0};
    //}

    processAlert(data: DTO.AlertMessage) {
        //console.log('setApiHeaderResponse call {' + data + '}');
        if (this.refs.cmpMainFrameRef) {
            this.setState({
                alerts: this.state.alerts.concat([data])
            });
        }

        return { return: 0 };
    }

    componentDidMount() {
        //TF.DataProcessBinding(this, { type: 'SYS.heartbeat', delegate: this.processHeartbeat });
        TF.DataProcessBinding(this, { type: 'DATA.newalert', delegate: this.processAlert });

        TF.CommandProcessBinding(this, { type: 'COMMAND.system', delegate: this.processSysCmd });

        TF.CommandProcessBinding(this, { type: 'COMMAND.SYS.UpdateConfig', delegate: this.processUpdateConfig });
    }

    componentWillUnmount() {
        TF.DataProcessUnBinding(this, { type: 'DATA.newalert', delegate: this.processAlert });
        TF.CommandProcessUnBinding(this, { type: 'COMMAND.system', delegate: this.processSysCmd });
        TF.CommandProcessUnBinding(this, { type: 'COMMAND.SYS.UpdateConfig', delegate: this.processUpdateConfig });
    }

    componentWillMount() {
        if (!Session.isloggedIn())
            this.props.history.replace('/login');

        if (!Session.isActiveTrader())
            this.props.history.replace('/');


        //let _user = Session.currentUser();

        //if (!_user)
        //    this.props.history.replace('/login');
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (!this.repoInit) {
            this.repoInit = true;
            TF.PublishCommandForceAgentFrame();

            //console.log('OtcRepoComponent.componentDidUpdate');
        }
    }


    public render() {
        //let footer_hb = this.state.online == undefined
        //    ? <p><em>Not availadble ...</em></p>
        //    : <AgentStatus syshdr={this.state ? this.state.syshdr : { sstamp: '' }} online={this.state ? this.state.online : undefined} />;

        //<Scroll.Element name="footer" />

        //<div className='row' id='footer_row'>
        //    {footer_hb}
        //</div>                    

        return <div ref="cmpMainFrameRef">
            <MainFrameComponent instruments={[]} currencies={[]} durations={[]} {...this.props} appstate={this.state} sysavail={this.state.sysavail} />
        </div>
    }

}




//import * as React from 'react';
//import { RouteComponentProps } from 'react-router';
////import * as Scroll from 'react-scroll';
//import * as DTO from '../service/DTOs';
//import * as TF from '../service/tradeflow';
//import { MainFrameComponent } from './MainFrame';
//import { Header } from './Header';
//import { Footer } from './Footer';
//import * as State from '../service/AppState';

//import 'isomorphic-fetch';

////var PropTypes = require('prop-types');

//export class OtcRepoComponent extends React.Component<RouteComponentProps<{}>, State.AppState> {
//    node_hb: HTMLDivElement | null;
//    repoInit: boolean;
//    constructor(props: RouteComponentProps<{}> ) {
//        super(props);
//        this.node_hb = null;
//        //this.state = {
//        //    syshdr: { sstamp: '' },
//        //    online: undefined,
//        //    alerts: []
//        //};
//        //this.context.
//        this.state = State.default;
//        this.repoInit = false;
//    }

//    processSysCmd(cmd: TF.SystemCommand) {
//        //console.log('setApiHeaderResponse call {' + data + '}');
//        if (this.refs.cmpMainFrameRef) {
//            //this.setState({
//            //    appstate: { syshdr: data, online: (data.time ? true : false) },
//            //});
//        }

//        return { return: 0, sstamp: this.state.syshdr.sstamp };
//    }

//    //processHeartbeat(data: DTO.SystemHeader) {
//    //    //console.log('setApiHeaderResponse call {' + data + '}');
//    //    if (this.refs.cmpMainFrameRef) {
//    //        this.setState({
//    //            syshdr: data, online: (data.time ? true : false) ,
//    //        });
//    //    }

//    //    return {return: 0};
//    //}

//    processAlert(data: DTO.AlertMessage) {
//        //console.log('setApiHeaderResponse call {' + data + '}');
//        if (this.refs.cmpMainFrameRef) {
//            this.setState({
//                alerts: this.state.alerts.concat([data])
//            });
//        }

//        return { return: 0 };
//    }

//    componentDidMount() {
//        //TF.DataProcessBinding(this, { type: 'SYS.heartbeat', delegate: this.processHeartbeat });
//        TF.DataProcessBinding(this, { type: 'DATA.newalert', delegate: this.processAlert});

//        TF.CommandProcessBinding(this, { type: 'COMMAND.system', delegate: this.processSysCmd});        
//    }

//    componentWillUnmount() {

//    }

//    componentDidUpdate(prevProps: any, prevState: any) {
//        if (!this.repoInit) {
//            this.repoInit = true;
//            TF.PublishCommandForceAgentFrame();

//            //console.log('OtcRepoComponent.componentDidUpdate');
//        }
//    }


//    public render() {
//        //let footer_hb = this.state.online == undefined
//        //    ? <p><em>Not availadble ...</em></p>
//        //    : <AgentStatus syshdr={this.state ? this.state.syshdr : { sstamp: '' }} online={this.state ? this.state.online : undefined} />;

//        //<Scroll.Element name="footer" />

//                    //<div className='row' id='footer_row'>
//                    //    {footer_hb}
//                    //</div>                    

//        return <div ref="cmpMainFrameRef">
//            <MainFrameComponent instruments={[]} currencies={[]} durations={[]} appstate={this.state} {...this.props} sysavail={this.state.sysavail} /> 
//               </div>
//    }

//}
